import React, { useState, forwardRef, useRef, useEffect } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import StillProcessingImagesInfo from '../informations/StillProcessingImagesInfo';
import {
  ALTERNATIVE,
  FACTOR_CODE,
  PARTICIPANT,
} from '../../../utils/variables';
import EventAvailableSearchActions from './EventAvailableSearchActions';

////////////////////////////////////////////
// TODO MISSING TESTS CASES - related to useEffect
////////////////////////////////////////////

const EventOnlineView = forwardRef((props, ref) => {
  const {
    customerKey,
    onlineEvent,
    showSearchInstructionsDialog,
    hasSmartSearchTab,
    hasExtendedSearch,
    onSearchTrigger,
    handleScrollToOffer,
    setFormRef,
    setAltSearchRef,
    shouldShowAdditionalInstruction,
    userLoginEmail,
    showHowToBuyHint,
    onShowHowToBuyHint,
    isAccessGrantedByValidCodeFaceEvent,
    codeSecondFactorForFaceEvent,
    showStillProcessingHint,
    setStillProcessingPosition,
    goBackToMainSearchResults,
    eventSecondFactorType,
    onScrollToSearchForm,
    shouldShowMainSearch,
    elementToAnimate,
    isParticipant,
    snFromUrl,
    hasDualSearchTab,
    searchTypeToForceShow,
    showAfterSearchDialog,
    onAfterSearchDialogAccept,
  } = props;

  const isMainEventPage = props.match.path === '/:language/event/:id';

  const [startNumber, setStartNumber] = useState(props.urlSn || '');
  const [secondFactor, setSecondFactor] = useState(
    customerKey
      ? window.atob(customerKey)
      : codeSecondFactorForFaceEvent
      ? window.atob(codeSecondFactorForFaceEvent)
      : ''
  );
  const [warnTextMessage, setWarnTextMessage] = useState();
  const searchStartNumber = props.urlSearchSn;
  const isMainSearchPage =
    props.match.path === '/:language/event/:id/search/:startnumber';

  const stillProcessigRef = useRef();

  const handleInputChange = (name, value) => {
    switch (name) {
      case 'startNumber':
        setStartNumber(value);
        break;
      case 'secondFactor':
        setSecondFactor(value);
        break;
    }
  };

  useEffect(() => {
    if (stillProcessigRef && setStillProcessingPosition) {
      setStillProcessingPosition(stillProcessigRef);
    }
  }, [stillProcessigRef]);

  useEffect(() => {
    if (isMainEventPage) {
      if (eventSecondFactorType != FACTOR_CODE) {
        if (!onlineEvent.participantUser && onlineEvent.dialogBeforeSecondFactor) {
          setWarnTextMessage(onlineEvent.dialogBeforeSecondFactor);
        }
        if (onlineEvent.participantUser && onlineEvent.dialogBeforeSearch) {
          setWarnTextMessage(onlineEvent.dialogBeforeSearch);
        }
      } else {
        if (onlineEvent.dialogBeforeSecondFactor && !codeSecondFactorForFaceEvent) {
          setWarnTextMessage(onlineEvent.dialogBeforeSecondFactor);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (
      onlineEvent.dialogBeforeSearch &&
      codeSecondFactorForFaceEvent &&
      isMainEventPage
    ) {
      setWarnTextMessage(onlineEvent.dialogBeforeSearch);
    }
  }, [codeSecondFactorForFaceEvent]);

  return (
    <div ref={ref}>
      <div className="row center-sm">
        <EventAvailableSearchActions
          info={onlineEvent}
          userLoginEmail={userLoginEmail}
          shouldShowAdditionalInstruction={shouldShowAdditionalInstruction}
          startNumber={startNumber}
          showHowToBuyHint={showHowToBuyHint}
          onShowHowToBuyHint={onShowHowToBuyHint}
          searchStartnumber={searchStartNumber}
          codeSecondFactorForFaceEvent={codeSecondFactorForFaceEvent}
          setMainSearchFormRef={setFormRef}
          onInputChange={handleInputChange}
          onSearchTrigger={onSearchTrigger}
          secondFactor={secondFactor}
          showSearchInstructionsDialog={showSearchInstructionsDialog}
          hasExtendedSearch={hasExtendedSearch}
          isAccessGrantedByValidCodeFaceEvent={isAccessGrantedByValidCodeFaceEvent}
          setAltSearchRef={setAltSearchRef}
          hasSmartSearchTab={hasSmartSearchTab}
          onScrollToSearchForm={onScrollToSearchForm}
          shouldShowMainSearch={shouldShowMainSearch}
          goBackToMainSearchResults={goBackToMainSearchResults}
          elementToAnimate={elementToAnimate}
          isParticipant={isParticipant}
          snFromUrl={snFromUrl}
          hasDualSearchTab={hasDualSearchTab}
          searchTypeToForceShow={searchTypeToForceShow}
          warnTextMessage={warnTextMessage}
          afterSearchMessage={onlineEvent.dialogAfterSearch}
          showAfterSearchDialog={showAfterSearchDialog}
          onAfterSearchDialogAccept={onAfterSearchDialogAccept}
        />
      </div>
      {showStillProcessingHint && (
        <div className="row" ref={stillProcessigRef}>
          <div className="col-xs-16 col-sm-12 col-sm-offset-2">
            <StillProcessingImagesInfo
              handleScrollToOffer={handleScrollToOffer}
              onGoBackToOffer={goBackToMainSearchResults}
              version={isMainSearchPage ? PARTICIPANT : ALTERNATIVE}
            />
          </div>
        </div>
      )}
    </div>
  );
});

EventOnlineView.displayName = 'EventOnlineView';

EventOnlineView.defaultProps = {
  hasExtendedSearch: true,
  urlSearchSn: '',
};

EventOnlineView.propTypes = {
  customerKey: PropTypes.string,
  onlineEvent: PropTypes.object,
  showSearchInstructionsDialog: PropTypes.bool,
  hasSmartSearchTab: PropTypes.bool,
  hasExtendedSearch: PropTypes.bool,
  onSearchTrigger: PropTypes.func,
  handleScrollToOffer: PropTypes.func,
  setFormRef: PropTypes.func,
  setAltSearchRef: PropTypes.func,
  shouldShowAdditionalInstruction: PropTypes.bool,
  userLoginEmail: PropTypes.string,
  showHowToBuyHint: PropTypes.bool,
  onShowHowToBuyHint: PropTypes.func,
  isAccessGrantedByValidCodeFaceEvent: PropTypes.bool,
  codeSecondFactorForFaceEvent: PropTypes.string,
  showStillProcessingHint: PropTypes.bool,
  setStillProcessingPosition: PropTypes.func,
  goBackToMainSearchResults: PropTypes.func,
  eventSecondFactorType: PropTypes.string,
  onScrollToSearchForm: PropTypes.func,
  shouldShowMainSearch: PropTypes.bool,
  elementToAnimate: PropTypes.string,
  isParticipant: PropTypes.bool,
  snFromUrl: PropTypes.string,
  searchTypeToForceShow: PropTypes.string,
  onAfterSearchDialogAccept: PropTypes.func,
  showAfterSearchDialog: PropTypes.bool,
};

export { EventOnlineView };

export default createFragmentContainer(withRouter(EventOnlineView), {
  onlineEvent: graphql`
    fragment EventOnlineView_onlineEvent on Event {
      id
      sgId
      hostResultUrl
      name
      participantUser
      mainSearch
      dialogAfterSearch
      dialogBeforeSearch
      dialogBeforeSecondFactor
      presale
      ...EventAvailableSearchActions_info
      ...StartNumberSearch_info
    }
  `,
});

